(function(global) {
	var PasswordTogglefication = function PasswordTogglefication(inputElement, newOptions) {
		if (inputElement.tagName !== 'INPUT') {
			console.warn('inputElement is not of type Input. Ignored.');
			return;
		}
		if (this === global) {
			throw new Error('This should be used as a constructor. Try "new PasswordTogglefication(element)"')
		}

		var self = this;
		var assign = Object.assign || (jQuery && jQuery.extend);

		self.options = assign({}, PasswordTogglefication.defaultOptions, newOptions);
		self.element = inputElement;
		self.parentElement = inputElement.parentNode;
		self.inputType = self.element.getAttribute('type') || 'text';

		self.wrapperElement = document.createElement(self.options.wrapperElementType);
		self.toggleButtonElement = document.createElement('button');
		self.toggleButtonElement.setAttribute('type', 'button');

		self.options.wrapperClass.split(' ').forEach(function(className) {
			self.wrapperElement.classList.add(className);
		});

		self.options.toggleButtonClass.split(' ').forEach(function(className) {
			self.toggleButtonElement.classList.add(className);
		});

		self.toggleButtonElement.addEventListener('click', function(e) {
			self.togglePassword();
			e.preventDefault();
		});

		self.element.addEventListener('blur', function() {
			if (!self.options.passwordOnBlur || !self.element.value) {
				return;
			}

			self.togglePassword(PasswordTogglefication.TYPES.PASSWORD);
		});

		self.parentElement.insertBefore(self.wrapperElement, self.element);
		self.wrapperElement.appendChild(self.element);
		self.wrapperElement.appendChild(self.toggleButtonElement);
		self.setType(self.options.startState);

		if (self.inputType === 'password') {
			self.inputType = 'text';
		}
	}

	PasswordTogglefication.prototype.togglePassword = function(setType) {
		var type = this.element.getAttribute('type');
		var toggledType = setType || (type === this.inputType ? PasswordTogglefication.TYPES.PASSWORD : PasswordTogglefication.TYPES.VISIBLE);
		this.setType(toggledType);
		this.options.toggleCallback(toggledType, this);
	};

	PasswordTogglefication.prototype.setType = function(type) {
		var isPassword = type === PasswordTogglefication.TYPES.PASSWORD;
		var fromClass = isPassword ? this.options.typeVisibleClass : this.options.typePasswordClass;
		var toClass = isPassword ? this.options.typePasswordClass : this.options.typeVisibleClass;
		var inputType = isPassword ? 'password' : this.inputType;

		this.element.setAttribute('type', inputType);
		this.toggleButtonElement.innerHTML = isPassword ? this.options.toggleButtonPasswordContent : this.options.toggleButtonVisibleContent;
		this.wrapperElement.classList.remove(fromClass);
		this.wrapperElement.classList.add(toClass);
	};

	PasswordTogglefication.TYPES = {
		PASSWORD: 'password',
		VISIBLE: 'visible'
	}

	PasswordTogglefication.defaultOptions = {
		wrapperElementType: 'div',
		wrapperClass: 'password-togglefication',
		typePasswordClass: 'password-togglefication-type-password',
		typeVisibleClass: 'password-togglefication-type-visible',
		toggleButtonClass: 'password-togglefication-button',
		toggleButtonPasswordContent: Alkami.Localization.SiteText['PasswordTogglefication.Show'],
		toggleButtonVisibleContent: Alkami.Localization.SiteText['PasswordTogglefication.Hide'],
		passwordOnBlur: true,
		startState: PasswordTogglefication.TYPES.PASSWORD,
		toggleCallback: function() {} //noop
	};

	global.PasswordTogglefication = PasswordTogglefication;

	if (global.ko) {
	    global.ko.bindingHandlers.passwordTogglefication = {
	        init: function (element, valueAccessor) {
	            var value = valueAccessor();
	            new PasswordTogglefication(element, ko.unwrap(value));
	        }
	    }
	}
})(window);
